import type { ReactNode } from "react";
import { ExerciseButtons } from "./exercise-buttons";

interface ExerciseLayoutProps {
  children: ReactNode;
  actions: ReactNode;
  className?: string;
  contentClassName?: string;
  actionsClassName?: string;
}

export function ExerciseLayout({
  children,
  actions,
  className = "",
  contentClassName = "",
  actionsClassName = "",
}: ExerciseLayoutProps) {
  return (
    <div className={`min-h-[90vh] flex flex-col px-4 ${className}`}>
      <div className={`flex-1 ${contentClassName}`}>{children}</div>

      <ExerciseButtons className={`mt-auto ${actionsClassName}`}>
        {actions}
      </ExerciseButtons>
    </div>
  );
}
